import { OrbitClass } from "../model/satellite";

// Palette from: http://tsitsul.in/blog/coloropt/
export const COLOR_PALETTE_ORBITS: Record<OrbitClass, string> = {
  'LEO': '#efe645',
  'MEO': '#00e3ff',
  'GEO': '#e1562c',
  'Elliptical': '#00b25d',
  '': '#999999',
};
